import AdministrativeOutwards from "./administrativeOutwards";

export {AdministrativeOutwards}